jQuery(document).ready(function ($) {
    let rightArrow = $('.comparison__arrows__next');
    let leftArrow = $('.comparison__arrows__previous');
    let tableLength = $('.comparison__content__table tr:first-child > td').length;
    let arrows = $('.comparison__arrows');
    let index = 0;
    let scroll = 0;
    let item = 254.4;
    let lastScroll;
    let hidden;
    let width = $(window).width();
    if ($('.general-container').length === 0) {
        lastScroll = 202;
        hidden = tableLength - 4;
        if ($('.comparison__content__table__row__info').length < 5) {
            arrows.css('display', 'none')
        }
    }  else {
        lastScroll = 114;
        hidden =  tableLength - 2;
        if ($('.comparison__content__table__row__info').length < 3) {
            arrows.css('display', 'none')
        }
    }

    if ($('.comparison__content__table__row__info').length <= 2) {
        rightArrow.css('display', 'none');
    }

    rightArrow.click(function (event) {
        event.preventDefault();

        index === hidden - 1 ? scroll -= lastScroll : scroll -= item;

        if (index < hidden) {
            index++;
            slide();
        }

        if (hidden === 1) {
            leftArrow.removeAttr('style')
            rightArrow.css('display', 'none')
        }

        index === hidden ? rightArrow.css('display', 'none') : leftArrow.removeAttr('style')
    });

    leftArrow.css('display', 'none');

    leftArrow.click(function (event) {
        event.preventDefault();

        index === 0 ? scroll += lastScroll : scroll += item;

        if (index === hidden) {
            scroll += lastScroll - item;
        }

        if (index !== 0) {
            index--;
            slide();
        }

        if (hidden === 1) {
            leftArrow.css('display', 'none')
            rightArrow.removeAttr('style')
        }

        index === 0 ? leftArrow.css('display', 'none') : rightArrow.removeAttr('style');
    });

    if (width < 768) {
        $('.slide_0').addClass('dots-active');

        $('.comparison__content').on('scroll', function (e) {
            let row = $('.comparison__content__table__row__licenses ');

            for (let i = 0; i < $(row).length; i++) {
                const result = isInViewport(row[i]);

                if (result) {
                    $('.slide_'+ i).addClass('dots-active').siblings().removeClass('dots-active');
                    break;
                }
            }
        });
    }

    function slide() {
        $('.comparison__content__table').animate({
            left: scroll + 'px'
        });
    }

    function isInViewport(element) {
        const rect = element.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
});